/* =======================================================================
   NJORD GEAR — FATHER'S DAY 2026  ·  Shared LP behaviour
   - Live countdown(s)            (.fday-countdown[data-deadline] | [data-rolling-hours])
   - Image gallery (thumb -> main) (.fday-prod-card / .fday-content-gallery)
   - Hero slider (carousel)        (.fday-slider)
   Idempotent.
   ======================================================================= */
(function () {
  if (window.__fdayInit) return;
  window.__fdayInit = true;

  var DEFAULT_DEADLINE = '2026-06-24T23:59:59-04:00';
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function renderCd(el, ms) {
    var ended = el.querySelector('[data-cd-ended]'), grid = el.querySelector('[data-cd-grid]');
    if (ms <= 0) { if (grid) grid.style.display = 'none'; if (ended) ended.style.display = ''; return false; }
    if (grid) grid.style.display = '';
    if (ended) ended.style.display = 'none';
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    var map = { days: d, hours: pad(h), mins: pad(m), secs: pad(s) };
    Object.keys(map).forEach(function (k) { var n = el.querySelector('[data-cd="' + k + '"]'); if (n) n.textContent = map[k]; });
    return true;
  }

  function startCd(el) {
    var rolling = parseFloat(el.getAttribute('data-rolling-hours'));
    var isRolling = !isNaN(rolling) && rolling > 0;
    var target;
    if (isRolling) {
      // Evergreen window anchored per-visitor; resets when it hits zero.
      var key = 'fday_cd_rolling_' + rolling;
      var now = Date.now();
      var stored = 0;
      try { stored = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
      if (!stored || stored <= now) { stored = now + rolling * 3600 * 1000; try { localStorage.setItem(key, String(stored)); } catch (e) {} }
      target = stored;
      // Sub-day window — hide the Days cell.
      var daysEl = el.querySelector('[data-cd="days"]');
      if (daysEl && daysEl.closest) { var cell = daysEl.closest('.fday-cd-cell'); if (cell) cell.style.display = 'none'; }
    } else {
      target = new Date(el.getAttribute('data-deadline') || DEFAULT_DEADLINE).getTime();
      if (isNaN(target)) target = new Date(DEFAULT_DEADLINE).getTime();
    }
    (function tick() {
      var ms = target - Date.now();
      if (isRolling && ms <= 0) {
        target = Date.now() + rolling * 3600 * 1000;
        try { localStorage.setItem('fday_cd_rolling_' + rolling, String(target)); } catch (e) {}
        ms = target - Date.now();
      }
      var alive = renderCd(el, ms);
      if (alive || isRolling) setTimeout(tick, 1000);
    })();
  }

  function initGallery(root) {
    var main = root.querySelector('[data-prod-main]');
    var thumbs = root.querySelectorAll('.fday-prod-thumb');
    if (!main || !thumbs.length) return;
    for (var i = 0; i < thumbs.length; i++) {
      (function (t) {
        t.addEventListener('click', function () {
          var src = t.getAttribute('data-full');
          if (src) main.setAttribute('src', src);
          for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.remove('is-active');
          t.classList.add('is-active');
        });
      })(thumbs[i]);
    }
  }

  function initSlider(el) {
    var track = el.querySelector('[data-slider-track]');
    var slides = el.querySelectorAll('.fday-slide');
    var dots = el.querySelectorAll('[data-slider-dots] button');
    var prev = el.querySelector('.fday-slider-arrow--prev');
    var next = el.querySelector('.fday-slider-arrow--next');
    var n = slides.length, i = 0, timer = null;
    if (n < 2 || !track) return;
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === i);
    }
    function arm() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 4500); }
    for (var j = 0; j < dots.length; j++) (function (k) { dots[k].addEventListener('click', function () { go(k); arm(); }); })(j);
    if (prev) prev.addEventListener('click', function () { go(i - 1); arm(); });
    if (next) next.addEventListener('click', function () { go(i + 1); arm(); });
    arm();
  }

  function init() {
    var cds = document.querySelectorAll('.fday-countdown');
    for (var i = 0; i < cds.length; i++) startCd(cds[i]);
    var gals = document.querySelectorAll('.fday-prod-card, .fday-content-gallery');
    for (var k = 0; k < gals.length; k++) initGallery(gals[k]);
    var sls = document.querySelectorAll('.fday-slider');
    for (var s = 0; s < sls.length; s++) initSlider(sls[s]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
